function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.test.js";
import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
var _excluded = ["context", "middlewareData", "placement", "refs", "strategy", "x", "y"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import { arrow, autoUpdate, flip, offset, safePolygon, shift, useFloating, useFocus, useHover, useInteractions } from '@floating-ui/react-dom-interactions';
import { useRef, useState } from 'react';
import getPopoverStyles from '../getPopoverStyles';
function usePopover(_ref) {
  var openOnFocus = _ref.openOnFocus,
    openOnHover = _ref.openOnHover,
    openOnMount = _ref.openOnMount,
    placement = _ref.placement,
    onClose = _ref.onClose,
    onOpen = _ref.onOpen,
    onBeforeOpen = _ref.onBeforeOpen,
    onBeforeClose = _ref.onBeforeClose,
    disableFloating = _ref.disableFloating;
  var crossAxis = !disableFloating;
  var mainAxis = !disableFloating;
  var _useState = useState(openOnMount),
    _useState2 = _slicedToArray(_useState, 2),
    isOpen = _useState2[0],
    setOpen = _useState2[1];
  var handleClose = function handleClose(e) {
    setOpen(false);
    onBeforeClose === null || onBeforeClose === void 0 || onBeforeClose(e);
    onClose === null || onClose === void 0 || onClose(e);
  };
  var handleOpen = function handleOpen(open) {
    setOpen(open);
    open && onOpen && onOpen();
    !open && onClose && onClose();
  };
  var handleToggle = function handleToggle(e) {
    setOpen(function (isOpen) {
      if (isOpen) {
        onBeforeClose === null || onBeforeClose === void 0 || onBeforeClose(e);
        onClose === null || onClose === void 0 || onClose(e);
      } else {
        onBeforeOpen === null || onBeforeOpen === void 0 || onBeforeOpen(e);
        onOpen === null || onOpen === void 0 || onOpen(e);
      }
      return !isOpen;
    });
  };
  var arrowRef = useRef(null);
  var _useFloating = useFloating({
      open: isOpen,
      placement: placement,
      middleware: [offset(8), flip({
        fallbackPlacements: ['top', 'bottom', 'left', 'right'],
        crossAxis: crossAxis,
        mainAxis: mainAxis
      }), shift({
        padding: 8
      }), arrow({
        element: arrowRef
      })],
      whileElementsMounted: autoUpdate,
      onOpenChange: handleOpen
    }),
    context = _useFloating.context,
    middlewareData = _useFloating.middlewareData,
    actualPlacement = _useFloating.placement,
    refs = _useFloating.refs,
    strategy = _useFloating.strategy,
    x = _useFloating.x,
    y = _useFloating.y,
    floatingValues = _objectWithoutProperties(_useFloating, _excluded);
  var _useInteractions = useInteractions([useFocus(context, {
      enabled: !!openOnFocus || !!openOnHover
    }), useHover(context, {
      enabled: !!openOnHover,
      handleClose: safePolygon()
    })]),
    getFloatingProps = _useInteractions.getFloatingProps,
    getReferenceProps = _useInteractions.getReferenceProps;
  var _ref2 = (middlewareData === null || middlewareData === void 0 ? void 0 : middlewareData.arrow) || {},
    arrowX = _ref2.x,
    arrowY = _ref2.y;
  var styles = getPopoverStyles({
    arrowX: arrowX,
    arrowY: arrowY,
    placement: actualPlacement,
    refs: refs,
    strategy: strategy,
    x: x,
    y: y
  });
  return _objectSpread(_objectSpread({}, floatingValues), {}, {
    arrowRef: arrowRef,
    isPopoverOpen: isOpen,
    placement: actualPlacement,
    styles: styles,
    getFloatingProps: getFloatingProps,
    getReferenceProps: getReferenceProps,
    handleClose: handleClose,
    handleToggle: handleToggle
  });
}
export default usePopover;